.lyne-form-field {
  border: 1px solid var(--sbb-color-smoke);
  border-radius: var(--sbb-border-radius-4x);
  margin-top: 1rem;
  padding: 1rem;
  display: flex;
  flex-direction: column;

  &.has-focus {
    border-color: black;
  }
}
